import useGetProductAdditionalData from './useGetProductAdditionalData'
export default useGetProductAdditionalData
